import { UseMutationOptions } from 'react-query/types/react/types'
import { useMutation, useQueryClient } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { buildErrorMessage } from 'utils'
import { WizardTourDismissal } from 'types'
import { WizardTourDismissalService } from 'api/services/WizardTourDismissalService'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

export type Options = Omit<UseMutationOptions<unknown, void, WizardTourDismissal>, 'mutationKey' | 'mutationFn'>

export const useCreateWizardTourDismissal = (options?: Options) => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const queryClient = useQueryClient()

  return useMutation<{ wizard_tour_dismissal: WizardTourDismissal }, void, WizardTourDismissal>(
    'createWizardTourDismissal',
    async (identifier: WizardTourDismissal) => {
      const response = await WizardTourDismissalService.createWizardTourDismissal(identifier)

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(
          buildErrorMessage(response.data.errors) ||
            'An error occurred! Our team has been notified and we are looking into it.',
        )
      }
      localStorage.setItem(`wizard_tour:${currentWorkspaceId}:${identifier}`, 'true')
      queryClient.invalidateQueries([currentWorkspaceId, 'wizardTourDismissal', identifier])
      return response.data
    },
    {
      ...options,
    },
  )
}
